export default __webpack_public_path__ + "static/media/wand-campain.c4ef13f4.svg";